import type { OptionChangedEvent } from 'devextreme/ui/data_grid';

const DATE_COLUMN_TYPES = ['date', 'datetime'];
const SORT_ORDER_OPTION = /^columns\[(\d+)\]\.sortOrder$/;

let registration: Promise<void> | undefined;

export function sortDateColumnsDescFirst(e: OptionChangedEvent): void {
    if (e.value !== 'asc' || e.previousValue === 'desc') {
        return;
    }
    const match = SORT_ORDER_OPTION.exec(e.fullName ?? '');
    if (!match) {
        return;
    }
    const index = Number(match[1]);
    const dataType = e.component.columnOption(index, 'dataType') as string | undefined;
    if (!dataType || !DATE_COLUMN_TYPES.includes(dataType)) {
        return;
    }
    e.component.columnOption(index, 'sortOrder', 'desc');
}

export function registerDateSortDescFirst(): Promise<void> {
    registration ??= import('devextreme/ui/data_grid').then(({ default: DataGrid }) => {
        DataGrid.defaultOptions({ options: { onOptionChanged: sortDateColumnsDescFirst } });
    });
    return registration;
}
